import { TestSMS } from 'widgets/TestSMS'
import { useBroadcastDetailModalContext } from 'pages/broadcasts/ui/BroadcastActions/ui/BroadcastDetailModal/context/context'
import { broadcastActionsStore } from 'pages/broadcasts/ui/BroadcastActions'

export const TestContent = () => {
  const broadcast = useBroadcastDetailModalContext()

  if (broadcast.type === 'ringless') return null

  return (
    <TestSMS
      params={broadcast.testSMSParams}
      request={broadcastActionsStore.onTestSMSBroadcast}
      isTopError
      disabled={broadcast.isInvalid}
    />
  )
}
